export default __webpack_public_path__ + "static/media/031-walrus.ace95cae.svg";